import { type NeighbouringImageProps } from './NeighbouringImage';
import { useCallback, useEffect } from 'react';
import { DirectionArrow } from '../Enums';

type ImagesByDirectionProps = {
  images: (NeighbouringImageProps | undefined)[] | undefined;
  goToNeighbouringImage: (image: NeighbouringImageProps) => void;
};

const keyToDirectionArrow: { [key: string]: DirectionArrow } = {
  ArrowUp: DirectionArrow.Up,
  ArrowLeft: DirectionArrow.Left,
  ArrowDown: DirectionArrow.Down,
  ArrowRight: DirectionArrow.Right,
};

export const ImagesByDirection = ({ images, goToNeighbouringImage }: ImagesByDirectionProps) => {
  const handleKeyDown = useCallback(
    (event: KeyboardEvent) => {
      if (event.altKey || event.shiftKey || !event.ctrlKey) {
        return;
      }
      if (!images) return;
      const key = event.key;
      if (!(key in keyToDirectionArrow)) return;
      const directionArrow = keyToDirectionArrow[key];
      const image = images[directionArrow];
      if (image) {
        // console.log('Go to ', DirectionArrow[directionArrow]);
        goToNeighbouringImage(image);
      }
    },
    [images, goToNeighbouringImage]
  );

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown, false);
    return () => {
      document.removeEventListener('keydown', handleKeyDown, false);
    };
  }, [handleKeyDown]);

  return <></>;
};
